module.exports = __webpack_public_path__ + "assets/img/bld-select.cd169708.png";